import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  padding: 4px 0;

  span:first-child {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
  span:last-child {
    color: ${({ theme }) => theme.colors.textPrimary};
    font-weight: 500;
    text-align: right;
    word-break: break-word;
  }
`;
